import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Search, Sparkles, Briefcase, ServerCog } from "lucide-react";

const ALL_SERVICES = [
  { path: "/seo", label: "SEO Services", desc: "Rank higher and win more organic traffic", icon: Search },
  { path: "/seo/auto-engine", label: "SEO Auto Engine", desc: "Instant AI-powered website audit", icon: Sparkles },
  { path: "/consulting", label: "IT Consulting", desc: "Expert advice on infrastructure and strategy", icon: Briefcase },
  { path: "/managed-services", label: "Managed IT Services", desc: "24/7 monitoring, security and support", icon: ServerCog },
];

// Contextual cross-links between service pages (crawlability + navigation)
export const RelatedServices = ({ current }) => {
  const items = ALL_SERVICES.filter((s) => s.path !== current);
  return (
    <section className="py-16 bg-white border-t border-slate-100" data-testid="related-services">
      <div className="container-wide">
        <h2 className="font-display text-2xl font-extrabold text-slate-900 mb-8">Explore our other services</h2>
        <div className="grid gap-5 sm:grid-cols-3">
          {items.map((s) => (
            <Link
              key={s.path}
              to={s.path}
              className="group rounded-2xl border border-slate-100 bg-slate-50 hover:bg-white hover:border-primary hover:shadow-md p-6 transition-all"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                <s.icon className="h-5 w-5" />
              </span>
              <p className="mt-4 font-display font-bold text-slate-900">{s.label}</p>
              <p className="mt-1 text-sm text-slate-500">{s.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
